exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.van-radio[data-v-37042a8c]{overflow:hidden\n}\n.inactive-icon[data-v-37042a8c]{width:5.6vw;height:5.6vw;border:1px solid #9faab4;-webkit-box-sizing:border-box;box-sizing:border-box;display:block;border-radius:100%\n}\n.active-icon[data-v-37042a8c]{width:5.6vw;height:5.6vw;border:none\n}\n", ""]);

// exports
